
import React, { useState } from 'react';
import { rlsBypassQuery } from '../api/rlsBypassQuery';
import '../style.css';
const VerifyVin = ({ darkMode }) => {
const [vin, setVin] = useState('');
const [uid, setuniqueid] = useState('');
const [vdetails, setVehicle] = useState(null);
const [message, setMessage] = useState('');
const [error, setError] = useState('');

const handleSubmit = async (e) => {
    
    e.preventDefault();

   

    

    try {
      const data = await rlsBypassQuery({
        table: 'modelreports',
        select: '*',
        filters: [
          { column: 'vin_number', operator: 'eq', value: vin },
          { column: 'customer_unique_id', operator: 'eq', value: uid },
        ],
        limit: 1,
      });

      const vehicle = data[0];
      if (!vehicle) {
        setVehicle(null);
        setError('No VIN register with this User Id. Please check the VIN number and Unique Id');
        return;
      }

      setVehicle(vehicle);
      setError('');
    } catch (error) {
      setVehicle(null);
      setError('No VIN register with this User Id. Please check the VIN number and Unique Id');
    }
  };


const handleVerify = () => {
if (vin.length === 17) {
setMessage(`✅ VIN ${vin} is valid!`);
} else {
setMessage('❌ VIN must be exactly 17 characters.');
}
};
//const lightBg = '/image/vbg.PNG';
return (
  <div  className="container-fluid shadow"style={{ backgroundColor: '#eef2f7'}}>
   <h1 className="text-center heading-title fw-bold">Verify Unique ID with VIN Number</h1>
   <p className='text-muted mb-4 text-center'>
    Quickly verify any vehicle by entering its VIN Number and Unique ID.
    Our system cross-checks the details against official records, ensuring complete accuracy & transparency. <br/>
    Perfect for importers, buyers, and compliance professionals who need reliable, real-time verification.
   </p>
   <div className="d-flex justify-content-center pb-4">
  <div className='row g-0 align-items-center'>
    
    <div className="col-lg-4 d-none d-lg-flex justify-content-center">

  <img
    src="/image/Check.svg"
    alt="VIN check illustration"
   style={{
  width: '100%',
  maxWidth: '200px',
  height: 'auto',
}}
  />

</div>

      
        

        {/*verify Form */}
        
        <div className="col-12 col-lg-8">
  
        
        

<form onSubmit={handleSubmit} className="w-100"style={{ maxWidth: '500px' }}>
  <div className="form-group mb-3">
    <input
      type="text"
      id="vin"
      className="form-control"
      value={vin}
      onChange={(e) => setVin(e.target.value)}
      placeholder="Enter VIN number"
      required
    />
  </div>
  <div className="form-group mb-3">
    <input
      type="text"
      id="id"
      className="form-control"
      value={uid}
      onChange={(e) => setuniqueid(e.target.value)}
      placeholder="Enter Unique ID"
      required
    />
  </div>
  <div className="col-12 text-center mt-3">
  <button type="submit" className="btn btn-success  " >Check VIN</button>
  </div>
</form>
{error && <div className="alert alert-danger mt-3">{error}</div>}
{vdetails && (
<div className="table-responsive mt-4">
    <h5 className="text-success">Match Found for {vdetails.vin_number}</h5>
    
        
        
  </div>
)}
</div>
</div>
</div>
</div>



);
};

export default VerifyVin;